module.exports = __webpack_public_path__ + "img/specialise.11ad67f6.svg";